<template>
  <div class="personal">
    <div class="per_top">
      <div class="per_men_lef" :class="$store.getters.isCollapse ? 'aside_f' : 'aside_t'">
        <el-menu
          default-active="1"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          :collapse="isCollapse"
          :default-openeds="opendes"
        >
          <div class="per_men_lef_img flex">
            <img class="imgone" v-if="!isCollapse" src="@/assets/img/info/info_icon.png" alt />
            <img class="imgtwo" v-else src="@/assets/img/home/foshologo2.png" alt />
          </div>
          <div class="emits mt20" :class="backgeStuts == -1 ? 'backcolor' : ''" @click="titleszu">
            <div class="emit_img flex">
              <img v-if="backgeStuts == -1" src="@/assets/img/info/01.png" alt />
              <img v-else src="@/assets/img/info/0001.png" alt />
            </div>
            <div
              class="menu_list_text1 sz14 cursor"
              :class="backgeStuts == -1 ? 'backcolor' : ''"
              v-if="!isCollapse"
            >个人中心</div>
          </div>
          <div v-for="(item, index) in queryMainPermitList" :key="index">
            <div @click="titlestwo(item, index)">
              <el-menu-item
                :index="index.toString()"
                style="padding-left: 0 !important;"
                v-if="!item.permits.length"
              >
                <div class="emit" :class="backgeStuts == item.title ? 'backcolor' : ''">
                  <div class="emit_img flex">
                    <div class="emit_img_ci flex" v-if="item.code == 'insight'">
                      <img v-show="backgeStuts == item.title" src="@/assets/img/info/02.png" alt />
                      <img v-show="backgeStuts != item.title" src="@/assets/img/info/002.png" alt />
                    </div>
                    <div class="emit_img_ci flex" v-if="item.code == 'my_concern'">
                      <img v-show="backgeStuts == item.title" src="@/assets/img/info/axb.png" alt />
                      <img v-show="backgeStuts != item.title" src="@/assets/img/info/axh.png" alt />
                    </div>
                    <div class="emit_img_ci flex" v-if="item.code == 'subAccount_mange'">
                      <img v-show="backgeStuts == item.title" src="@/assets/img/info/axb.png" alt />
                      <img v-show="backgeStuts != item.title" src="@/assets/img/info/axh.png" alt />
                    </div>
                    <div class="emit_img_ci flex" v-if="item.code == 'market_place'">
                      <img src="@/assets/img/info/lmjy.png" alt />
                    </div>
                    <div class="emit_img_ci flex" v-if="item.code == 'ai_spark'">
                      <img src="@/assets/img/info/AISPARK.png" alt />
                    </div>
                  </div>
                  <div
                    class="menu_list_text1"
                    :class="backgeStuts == item.title ? 'backcolor' : ''"
                    v-if="!isCollapse"
                  >
                    {{ queryMainPermitList[index].title }}
                    <el-tooltip class="item" effect="dark" placement="right" content>
                      <div slot="content">
                        <p>一键发布独立站和三方平台的联盟营销任务</p>
                        <p>智能推荐与精准匹配高转化联盟伙伴</p>
                        <p>联盟伙伴智能接单推广</p>
                        <p>实现品牌及经营双增长</p>
                      </div>
                      <i v-if="item.code == 'market_place'" class="el-icon-info"></i>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" placement="right" content>
                      <div slot="content">
                        <p>更懂品牌和渠道的联盟营销专有AIGC</p>
                        <p>实现多场景营销素材智能生成</p>
                      </div>
                      <i v-if="item.code == 'ai_spark'" class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>
              </el-menu-item>
            </div>
            <div @click="titlestwos(item, index)">
              <el-submenu :index="index.toString()" v-if="item.permits.length">
                <template slot="title">
                  <div class="emit" :class="backgeStuts == item.title ? 'backcolor' : ''">
                    <div class="emit_img flex">
                      <div class="emit_img_ci flex" v-if="item.code == 'email'">
                        <img v-if="backgeStuts == item.title" src="@/assets/img/info/03.png" alt />
                        <img v-else src="@/assets/img/info/003.png" alt />
                      </div>
                      <div class="emit_img_ci flex" v-if="item.code == 'platform_manage'">
                        <img v-if="backgeStuts == item.title" src="@/assets/img/info/dpt2.png" alt />
                        <img v-else src="@/assets/img/info/dpt1.png" alt />
                      </div>

                      <div v-if="queryMainPermitList[index].isLock == '0'" class="emit_icon_top">
                        <div class="emit_icon" v-if="!isCollapse">
                          <span v-if="item.code == 'email'">
                            <i
                              v-if="iconStuts"
                              class="el-icon-caret-right"
                              :class="backgeStuts == item.title ? 'coff' : ''"
                            ></i>
                            <i
                              v-else
                              class="el-icon-caret-bottom"
                              :class="backgeStuts == item.title ? 'coff' : ''"
                            ></i>
                          </span>
                          <span v-if="item.code == 'platform_manage'">
                            <i
                              v-if="iconStutstwo"
                              class="el-icon-caret-right"
                              :class="backgeStuts == item.title ? 'coff' : ''"
                            ></i>
                            <i
                              v-else
                              class="el-icon-caret-bottom"
                              :class="backgeStuts == item.title ? 'coff' : ''"
                            ></i>
                          </span>
                          <span v-if="item.code == 'subAccount_mange'">
                            <i
                              v-if="iconStutsthree"
                              class="el-icon-caret-right"
                              :class="backgeStuts == item.title ? 'coff' : ''"
                            ></i>
                            <i
                              v-else
                              class="el-icon-caret-bottom"
                              :class="backgeStuts == item.title ? 'coff' : ''"
                            ></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      class="menu_list_text1"
                      :class="backgeStuts == item.title ? 'backcolor' : ''"
                      v-if="!isCollapse"
                    >
                      {{ queryMainPermitList[index].title }}
                      <span
                        v-if="queryMainPermitList[index].code !== 'email' && queryMainPermitList[index].code !== 'platform_manage'"
                      ></span>
                      <i v-if="queryMainPermitList[index].isLock == 1" class="el-icon-lock"></i>
                    </div>
                  </div>
                </template>
                <el-menu-item-group>
                  <div class="emit_list">
                    <div
                      class="emit_list_cen"
                      v-for="(itm, index) in queryMainPermitList[index].permits"
                      :key="index"
                      @click.stop="emitck(itm, index)"
                    >
                      <div class="emit_list_cen_img"></div>
                      <div
                        class="emit_list_cen_text cursor sz14"
                        :class="(emitco == itm.title) && (backgeStuts == '邮箱建联' || backgeStuts == '多平台管理') ? 'emitcolor' : ''"
                      >
                        {{ itm.title }}
                        <i
                          v-if="itm.isLock === '1' && (itm.code !== 'auth_center' && itm.code !== 'source')"
                          class="el-icon-lock"
                        ></i>
                      </div>
                    </div>
                  </div>
                </el-menu-item-group>
              </el-submenu>
            </div>
          </div>

          <div class="menu_butt">
            <el-button
              class="menu_icon"
              style="height: 100%"
              icon="el-icon-s-fold"
              v-if="!isCollapse"
              @click.stop="opentab(1)"
            ></el-button>
            <el-button
              class="menu_icon"
              style="height: 100%"
              icon="el-icon-s-unfold"
              v-else
              @click.stop="opentab(2)"
            ></el-button>
          </div>
        </el-menu>
      </div>
    </div>
  </div>
</template>
<script>
import { QUERYMAINPERMIT } from "../api/heder";
import { setLocaData, getLocaData } from "@/utils/common";
import { TEST111 } from "@/api/login";
// import baseUrl from "../../utils/config"
import axios from "axios";
export default {
  //   components: { cutting, emailConnection, mailcenter, inbox, outbox },
  data() {
    return {
      opendes: ["4"],
      emitco: localStorage.getItem("isemitco"), // 邮箱建联选中状态
      iconStuts: true,
      iconStutstwo: true,
      iconStutsthree: true,
      kfStuts: false, // 客服状态
      kfStutstwo: false,
      isCollapse: false,
      backgeStuts: getLocaData("isSelect"),
      nologin: true,
      name: "",
      url: process.env.VUE_APP_BASE_API,
      isactive: -1,
      queryMainPermitList: []
    };
  },
  watch: {
    isCollapse: {
      deep: true,
      handler(val) {
        this.$store.commit("changeIsCollapse", { isCollapse: val });
      }
    }
  },
  created() {
    // 创建vm实例后执行
    // 浏览器控制按钮前进后退触发函数
    window.addEventListener("popstate", this.popstate, false);
  },
  destroyed() {
    // 销毁vm组件
    // 避免堆栈溢出，多次创建、多次触发
    window.removeEventListener("popstate", this.popstate, false);
  },
  mounted() {
    this.queryMainPermit();
  },
  methods: {
    popstate() {
      this.backgeStuts = getLocaData("isSelect");
      this.emitco = getLocaData("isemitco");
    },
    queryMainPermit() {
      QUERYMAINPERMIT().then(res => {
        //  正在开发开始
        // let arr1 = res.data.body
        // arr1.push({
        //   code: 'subAccount_mange',
        //   isLock: '0',
        //   logoClick: null,
        //   logoView: null,
        //   parentCode: null,
        //   permits: [],
        //   routAddr: '/subAccountList',
        //   title: '子账号管理',
        //   validParam: 'zzhg',
        // })
        //  正在开发结束
        // this.queryMainPermitList = arr1
        this.queryMainPermitList = res.data.body;
        setLocaData("permitList", this.queryMainPermitList);
      });
    },
    buttcilk() {
      this.buttstuts = 2;
      setLocaData("isbutt", this.buttstuts);
    },
    // 移入事件
    mouseover() {
      this.kfStuts = true;
    },
    // 移出事件
    mouseout() {
      this.kfStuts = false;
    },
    // 移入事件
    mouseovertwo() {
      this.kfStutstwo = true;
    },
    // 移出事件
    mouseouttwo() {
      this.kfStutstwo = false;
    },
    titlestwo(e, index) {
      if (e.isLock !== "0") {
        this.$bus.$emit("showNopermiss", true);
        return;
      } else if (e.code == "market_place") {
        window.open("https://marketplace.foshotech.com/register");
      } else if (e.code == "ai_spark") {
        this.$bus.$emit("showAiSpark", true);
        return;
      } else {
        if (e.code == "insight") {
          if (JSON.parse(localStorage.getItem("haveIndustry"))) {
            this.titlestuts = true;
          } else {
            this.$bus.$emit("showNoIndustry", true);
            return;
          }
        } else {
          this.titlestuts = false;
        }
        this.backgeStuts = e.title;
        setLocaData("isSelect", this.backgeStuts);
        if (e.validParam === null) {
        } else {
          setLocaData("validParam", e.validParam);
          this.$router.push(e.routAddr);
        }
      }
    },
    titlestwos(e, index) {
      if (e.code == "email") {
        this.iconStuts = !this.iconStuts;
        this.emitco = "邮件中心";
        this.$router.push(e.permits[0].routAddr);
        setLocaData("validParam", e.permits[0].validParam);
      } else if (e.code == "platform_manage") {
        this.iconStutstwo = !this.iconStutstwo;
        this.$router.push(e.permits[1].routAddr);
        this.emitco = e.permits[1].title;
        setLocaData("validParam", e.permits[1].validParam);
      }
      this.backgeStuts = e.title;
      setLocaData("isemitco", this.emitco);
      setLocaData("isSelect", this.backgeStuts);
    },
    emitck(e, index) {
      if (e.isLock !== "0" && e.code != "auth_center" && e.code != "source") {
        this.$bus.$emit("showNopermiss", true);
        return;
      } else {
        if (
          e.title == "授权中心" ||
          e.title == "综合看板" ||
          e.title == "报告详情" ||
          e.title == "素材管理" ||
          e.title == "综合看板Demo" ||
          e.title == "报告详情Demo" ||
          e.title == "素材管理Demo"
        ) {
          this.backgeStuts = "多平台管理";
        } else {
          this.backgeStuts = "邮箱建联";
        }
        setLocaData("isSelect", this.backgeStuts);
        this.emitco = e.title;
        setLocaData("isemitco", e.title);
        if (e.validParam === null) {
        } else {
          setLocaData("validParam", e.validParam);
          this.$router.push(e.routAddr);
        }
      }
    },
    titleszu() {
      this.backgeStuts = -1;
      setLocaData("isSelect", this.backgeStuts);
      this.$router.push("./info");
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    // 侧边栏展开
    opentab(e) {
      this.isCollapse = !this.isCollapse;
    }
  }
};
</script>
<style lang="less" scoped>
.men_list {
  width: 96%;
}

.iclusd {
  position: absolute;
  right: 0;
}

.top_input {
  height: 69px;
  position: fixed;
  top: 0;
  left: 12%;
  z-index: 998 !important;
  align-items: center;

  .unmaeinput {
    width: 450px;
  }

  .searchs {
    width: 56px;
    height: 28px;
    line-height: 28px;
  }
}

.top_input_list {
  position: fixed;
  top: 60px;
  left: 12%;
  z-index: 999;
  width: 450px;
  box-shadow: 0px 0px 20px 1px rgba(0, 0, 0, 0.05);

  .list {
    width: 100%;
    padding: 0 30px;

    .contern {
      width: 100%;
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #e7e8f2;
    }

    span {
      color: #ccc;
      display: inline-block;
    }
  }

  .list:hover {
    background: rgba(0, 0, 0, 0.05);
  }
}

.coff {
  color: #fff;
}

.starMarks {
  width: 26px;
  height: 26px;
  line-height: 26px;
  background: #d9dee7;
  color: #000;
  margin-left: 46px;
}

.emit {
  height: 100%;
  width: 100%;
  display: flex;
  position: relative;
  align-items: center;

  .emit_img {
    // width: 30px;
    width: 100%;
    height: 100%;
    align-items: center;
    position: absolute;
    left: 10px;
    top: 0;

    // margin-top: -13px;
    .emit_img_ci {
      height: 100%;
      align-items: center;
    }

    .emit_icon_top {
      width: 40px;
      height: 100%;
      position: absolute;
      right: 10%;
      top: 0;
      align-items: center;
    }

    img {
      width: 30px;
      height: 30px;
    }
  }

  .menu_list_text {
    height: 100%;
    line-height: 50px;
    margin-left: 60px;
  }

  .menu_list_text1 {
    margin-left: 60px;
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #303133;
    z-index: 999;

    .item {
      margin-left: 5px;
    }

    i {
      color: #909399;
      display: inline-block !important;
      z-index: 999;
    }
  }

  .emit_icon {
    i {
      display: inline;
    }
  }
}

.emits {
  height: 50px;
  min-height: 34px !important;
  width: 90%;
  display: flex;
  position: relative;
  align-items: center;

  .emit_img {
    height: 100%;
    min-height: 34px !important;
    position: absolute;
    left: 10px;
    top: 0;
    display: flex;
    align-items: center;

    img {
      width: 30px;
      height: 30px;
    }

    @media screen and (min-width: 1000px) and (max-width: 2000px) {
      .emit_icon_top {
        position: absolute;
        right: -170px;
        top: -15px;
      }
    }

    @media screen and (min-width: 2000px) and (max-width: 3000px) {
      .emit_icon_top {
        position: absolute;
        right: -170px;
        top: -15px;
      }
    }
  }

  .menu_list_text {
    height: 100%;
    line-height: 50px;
    margin-left: 60px;
  }

  .menu_list_text1 {
    margin-left: 60px;
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #303133;
  }

  .emit_icon {
    i {
      display: inline;
    }
  }
}

.emitcolor {
  color: #be3c6e;
}

.emit_list {
  .emit_list_cen {
    height: 50px;
    // padding: 0 40px;
    padding-left: 40px;
    padding-right: 0;
    display: flex;

    .emit_list_cen_img {
      height: 100%;
      line-height: 58px;

      img {
        width: 20px;
      }
    }

    .emit_list_cen_text {
      margin-left: 10px;
      height: 100%;
      line-height: 50px;
      align-items: center;
    }
  }
}

.title_top {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5, #000);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
}

.nologins_title {
  width: 400px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -200px;
  margin-left: -200px;
  background: #fff;
  border-radius: 15px;
  padding: 20px;
}

.nologins_title_icon {
  width: 100%;
  text-align: right;
  font-size: 26px;
  padding-right: 10px;

  i {
    color: #000;
  }
}

.nologins_title_img {
  width: 200px;
  height: 200px;
  margin: 0 auto;
  margin-top: 10px;

  img {
    width: 200px;
    height: 200px;
    display: inline-block;
    margin: 0 auto;
  }
}

.nologins_title_text {
  width: 100%;
  margin-top: 20px;

  span {
    color: #ccc;
  }
}

.nologins {
  width: 170px;
  height: 50px;
  font-size: 14px;
  line-height: 50px;
}

.nologins:hover {
  background: rgba(166, 168, 191, 0.25);
}

.addclass {
  border: 1px solid;
  border-radius: 50%;
}

.per_top {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;

  .top {
    // width: 100%;
    width: calc(100% - 250px);
    height: 69px;
    background: #fff;
    box-shadow: 0px 1px 0px 1px #e7e8f2;
    background: #ffffff;
    border-radius: 0px 0px 0px 0px;
    position: absolute;
    top: 0;
    right: 0;

    .top_left {
      width: 10%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 150px;
        height: 53px;
      }
    }

    .top_right {
      // width: 22%;
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      display: flex;

      .top_right_one {
        border-left: 1px solid #e7e8f2;
        // width: 55%;
        height: 100%;
        display: flex;

        .top_right_one_img {
          position: relative;
          border-right: 1px solid #e7e8f2;

          .info {
            width: 20px;
            height: 20px;
            line-height: 20px;
            background: #be3c6e;
            color: #fff;
            font-size: 12px;
            position: absolute;
            top: 15%;
            right: 15%;
          }
        }

        .top_kf {
          width: 69px;
          height: 69px;
          border-right: 1px solid #e7e8f2;
          display: flex;
          justify-content: center;
          align-items: center;
          object-fit: cover;

          .scale_img {
            width: 50%;
            height: 50%;
            transition: 0.2s;
          }

          .scale_img:hover {
            transform: scale(1.5);
          }
        }
      }

      .top_right_she {
        height: 100%;
        width: 170px;
        display: flex;
        position: relative;

        i {
          position: absolute;
          font-size: 18px;
          right: -10px;
          top: 50%;
          margin-top: -9px;
        }
      }

      .usname {
        width: 150px;
        display: inline-block;
        height: 69px;
        line-height: 69px;
        padding: 0 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .top_right_two {
        // width: 45%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .top_right_two_r {
          // width: 40%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          .top_right_two_r_img {
            // width: 70%;
            width: 50px;
            height: 50px;
            padding-left: 30px;
            border-radius: 50%;
            display: flex;
            box-sizing: border-box;
            justify-content: center;
            align-items: center;

            img {
              width: 50px;
              height: 50px;
              // width: 100%;
              // height: 100%;
              border-radius: 50%;
              box-shadow: 10px 10px 10px 2px rgb(244, 244, 247);
              // height: ;
            }
          }
        }

        .top_right_two_text {
          height: 100%;
          margin-left: 20px;
          display: flex;
          justify-content: center;
          align-items: center;

          div {
            width: 100%;
            height: 40%;

            p {
              height: 100%;
              line-height: 36px;
              width: 140px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }

            .p1 {
              font-size: 14px;
              color: #25233a;
              margin-bottom: 5px;
            }

            .p2 {
              font-size: 12px;
              color: #8b8c99;
            }
          }
        }
      }
    }
  }

  .butt {
    width: 90%;
    height: 50px;
    position: fixed;
    bottom: 0;
    left: 10%;

    div {
      width: 100%;
      height: 100%;
      position: relative;

      i {
        position: absolute;
        right: 10px;
        font-size: 20px;
        cursor: pointer;
      }
    }
  }

  .toptwo {
    width: 98%;
  }

  .topsher {
    width: 98%;
    left: 2%;
  }

  .wxkf {
    width: 24%;
    height: 130px;
    background: #fff;
    position: fixed;
    top: 110px;
    right: 30px;
    z-index: 999999;
    box-shadow: 10px 2px 10px 10px rgb(244, 244, 247);
    display: flex;

    .wxkf_img {
      height: 100%;

      img {
        height: 100%;
      }
    }

    .wxkf_text {
      height: 100%;
      padding: 25px 0;
      margin-left: 20px;

      p {
        // font-weight: bold;
        font-size: 20px;
      }
    }
  }
}

.hedimg {
  width: 100%;
  text-align: center;

  .hedimg_img {
    display: inline-block;
    height: 100%;
    margin: 5px;

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      display: block;
      box-sizing: border-box;
    }

    // background: pink;
  }
}

// @media screen and (min-width: 2560px) {
.indeulist {
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
}

.indeulist:hover {
  background: #d8dee8;
}

.sclct {
  margin-top: 100px;
  position: relative;

  .sclct_div {
    width: 50%;
    text-align: left;
  }

  .sclct_title {
    font-size: 40px;
    font-weight: 600;
    margin-bottom: 20px;
  }

  .sclct_le {
    margin-bottom: 60px;

    .sclct_one {
      width: 304px;
      height: 40px;
      font-size: 30px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 60px;
      letter-spacing: 0px;
      color: #707070;
      margin-right: 75px;
    }

    .add {
      width: 101px;
      height: 51px;
      line-height: 51px;
      border-radius: 5px;
      border: solid 3px #be3c6e;
      text-align: center;
    }
  }

  .sclctr_top {
    //  height: 750px;
    //  background: pink;
    .sclctr {
      width: 300px;
      height: 40px;
      line-height: 40px;
      border-bottom: 2px solid #e7e8f2;
      margin-bottom: 50px;
      position: relative;
      color: #33343d;

      .sclctr_one {
        position: absolute;
        left: 0;
      }

      .sclctr_two {
        position: absolute;
        right: 0;
      }
    }
  }
}

.com_top_xf {
  width: 100%;
  height: 100px;
  line-height: 100px;
  text-align: center;
  margin: 40px 0;
}

.nologin {
  width: 100%;
  display: flex;

  .nologin_img {
    width: 444px;
    height: 444px;
    border-radius: 50%;
    margin-left: 173px;
    margin-top: 207px;
    margin-right: 115px;

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }

  .nologin_text {
    font-size: 50px;
    margin-top: 250px;
    height: 230px;

    .nologin_te_one {
      color: #404040;
    }
  }

  .nologin_te_two {
    width: 256px;
    height: 122px;
    background-color: #be3c6e;
    border-radius: 5px;
    border: solid 3px #be3c6e;
    color: #fff;
    line-height: 122px;
    margin-top: 100px;
  }
}

.hedimg_img {
  width: 18%;
}

.bott {
  width: 188px;
  height: 84px;
  text-align: center;
  line-height: 84px;
  background: #be3c6e;
  border-radius: 5px;
  color: #fff;
}

// .conten_box {
//   padding-left: 40px;
// }
.bcedits {
  height: 84px;
  line-height: 84px;
}

.preserve_a {
  width: 400px;
  text-align: center;
  position: absolute;
  right: -50px;
  bottom: -100px;

  span {
    display: inline-block;
    border-bottom: 1px solid #be3c6e;
  }

  .xinxin {
    color: #be3c6e;
  }
}

.personal {
  // padding-top: 100px;
  //   margin-top: 100px;
  position: fixed;
  z-index: 999;

  .w64 {
    margin-left: 64px;
  }

  .mg15 {
    margin-left: 12%;
  }

  //   width: 100%;
  //   height: 100%;
  overflow-x: hidden;
  background: #fafafd;

  .w15 {
    width: 10%;
  }

  .per_top {
    width: 100%;
    display: flex;

    .per_men_lef {
      width: 250px;
      // min-width: 135Px !important;
      position: fixed;
      height: 100%;
      left: 0;
      top: 0;
      box-sizing: border-box;
      // border-right: 1px solid #e6e6e6;
      z-index: 999 !important;

      .per_men_lef_img {
        width: 100%;
        height: 69px;
        align-items: center;
        justify-content: center;

        .imgone {
          width: 130px;
          height: 47px;
        }

        .imgtwo {
          width: 42px;
        }
      }

      .per_menu_icon {
        height: 92px;
        line-height: 92px;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 150px;
          height: 55px;
        }

        .per_menu_icon_two {
          width: 40px;
          height: 40px;
        }
      }

      .menu_list {
        width: 100%;
        height: 100%;
        border-radius: 0px 5px 5px 0px;
        position: relative;

        .menu_list_img {
          width: 30px;
          height: 30px;
          position: absolute;
          left: 40px;
          top: 50%;
          margin: -30px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .menu_list_text {
          // width: 100%;
          height: 100%;
          line-height: 50px;
          margin-left: 60px;
        }
      }

      .backcolor {
        background: #be3c6e;
        color: #fff;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
      }

      .menu_butt {
        width: 100%;
        height: 50px;
        position: absolute;
        bottom: 0;
        text-align: right;
        line-height: 50px;
        border-top: 1px solid #e6e6e6;

        .menu_icon {
          border: none;
          font-size: 28px;
        }

        img {
          width: 40px;
          height: 40px;
        }
      }
    }
  }

  .qsa {
    background: #be3c6e;
  }

  .bceditsposhn {
    position: absolute;
    right: 0;
    bottom: 50px;
  }

  .conten_box {
    // width: 100%;
    height: 100%;
    max-width: 1920px;
    min-width: 1500px;
    margin: 0 auto;
    margin-left: 12%;
    background: rgb(250, 250, 253);
    position: relative;

    .con_title {
      width: 100%;
      height: 92px;
      text-align: left;
      line-height: 92px;
      font-size: 18px;
      font-weight: 600;
    }

    .con_title_top {
      width: 95%;
      padding-bottom: 50px;
      border-bottom: 1px solid #e7e8f2;
      display: flex;
      position: relative;

      .bcedits {
        position: absolute;
        bottom: 50px;
        right: 0;
      }

      .preserve {
        width: 188px;
        height: 84px;
        text-align: center;
        line-height: 84px;
        background: #be3c6e;
        border-radius: 5px;
        color: #fff;
        position: absolute;
        right: 0;
        bottom: 50px;
      }
    }

    .details {
      width: 300px;
      height: 315px;
      background: #fff;
      // position: absolute;
      box-shadow: 10px 10px 10px 2px rgb(244, 244, 247);

      // right: 40px;
      // top: 20px;
      .con_top {
        width: 100%;
        font-size: 16px;
        margin: 20px 0;
      }

      .con_viv {
        color: #404040;
        font-size: 12px;
        margin-bottom: 20px;
        width: 100%;
      }

      .com_imh {
        width: 124px;
        height: 124px;
        border-radius: 50%;
        margin: 0 auto;
        box-shadow: 10px 10px 10px 2px rgb(244, 244, 247);

        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }

      .con_edit {
        width: 138px;
        height: 38px;
        background: #be3c6e;
        color: #fff;
        border-radius: 5px;
        line-height: 38px;
        margin: 0 auto;
        margin-top: 20px;
      }
    }
  }

  .conten_cutt_top {
    padding-left: 10%;
    box-sizing: border-box;
    width: 98%;

    .conten_cutt {
      // width: 90%;
      max-width: 1920px;
      min-width: 1500px;
      margin: 0 auto;
      padding-left: 30px;
      // margin-left: 10%;
    }
  }

  .com_top {
    position: relative;

    .purchase {
      min-height: 200px;
      padding: 100px 0;
    }

    .immediately {
      width: 70px;
      height: 80px;
      line-height: 135px;
      border-bottom: 2px solid #707070;
    }
  }
}

.com_form {
  width: 30%;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  // width: 200px;
  width: 100%;
  height: 100%;
  // min-height: 400px;
}

.el-menu-vertical-demo[data-v-1b92c146]:not(.el-menu--collapse) {
  height: 100%;
  width: 100%;
}

.el-menu-item {
  width: 90%;
  text-align: left;
  padding: 0;
  height: 50px;
  margin: 40px 0;
}

.el-menu-item.is-active {
  color: #000;
  background: #fff;
}

.el-menu-item:hover {
  background: #fff;
}

.el-menu--collapse {
  height: 100%;
}

.el-radio-button__inner {
  background: pink;
}
</style>
<style lang="less">
.el-menu-vertical-demo {
  border: none;
}

.down_popover {
  padding: 20px 0;
  border-radius: 5px;
  height: 250px;
  overflow: auto;
}

.personal {
  .el-radio-button__inner {
    background: #fff;
    width: 64px;
    height: 65px;
    line-height: 50px;
    border: none;
  }

  .el-radio-button:first-child .el-radio-button__inner {
    border: none;
  }

  .el-radio-button__inner {
    border: none;
  }

  .el-table--border .el-table__cell,
  .el-table__body-wrapper
    .el-table--border.is-scrolling-left
    ~ .el-table__fixed {
    border-right: 1px solid #fff;
  }

  .el-button:hover {
    background: #fff;
  }

  .el-menu-vertical-demo {
    min-height: 100%;
    width: 65px;
  }

  .el-select-dropdown__item {
    color: #000;
  }

  .el-select-dropdown__item.selected {
    color: #be3c6e;
  }

  .el-form-item__label {
    text-align: right;
  }

  .el-collapse-item__header {
    border: none;
    height: 64px;
    // background: #be3c6e;
    border-radius: 0px 5px 5px 0px;
  }

  .el-collapse {
    border: none;
  }
}

.el-submenu__title {
  padding-left: 0 !important;
  padding: none !important;
  background: #fff;
}

.el-submenu__title:hover {
  background: #fff !important;
}

.personal {
  .el-icon-arrow-down:before {
    display: none;
  }
}

.top_input {
  .el-input__inner {
    border: none;
    height: 55px !important;
  }
}

.el-submenu__title {
  padding-right: 8px !important;
}

.el-submenu {
  margin: 10px 0 !important;
}

.el-menu-item {
  margin: 10px 0 !important;
}

.el-submenu__icon-arrow {
  right: 8px !important;
}
</style>